import createIcon from '../../createIcon';

/**
 * @component @name SortByAlpha
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTUuMjE1IDQuNjU5OEgxMC40OTVMMTIuODU1IDIuMjk5OEwxNS4yMTUgNC42NTk4Wk0xMC41MjUgMTkuMzY5OEgxNS4xODVMMTIuODU1IDIxLjY5OThMMTAuNTI1IDE5LjM2OThaTTYuMzc1IDYuMjY5OEwxLjg3NSAxNy43Mjk4SDMuNzE1TDQuNjM1IDE1LjI3OThIOS43NDVMMTAuNjY1IDE3LjcyOThIMTIuNTA1TDguMDE1IDYuMjY5OEg2LjM3NVpNNS4yNDUgMTMuNjM5OEw3LjE4NSA4LjQ1OThMOS4xMjUgMTMuNjM5OEg1LjI0NVpNMTYuMDA1IDE2LjEzOThIMjIuMTI1VjE3LjcyOThIMTMuNTk1VjE2LjQzOThMMTkuNTE1IDcuODc5OEgxMy42MzVWNi4yNzk4SDIxLjkzNVY3LjUzOThMMTYuMDA1IDE2LjEzOThaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SortByAlpha = createIcon('SortByAlpha', [
  [
    'path',
    {
      d: 'M15.215 4.6598H10.495L12.855 2.2998L15.215 4.6598ZM10.525 19.3698H15.185L12.855 21.6998L10.525 19.3698ZM6.375 6.2698L1.875 17.7298H3.715L4.635 15.2798H9.745L10.665 17.7298H12.505L8.015 6.2698H6.375ZM5.245 13.6398L7.185 8.4598L9.125 13.6398H5.245ZM16.005 16.1398H22.125V17.7298H13.595V16.4398L19.515 7.8798H13.635V6.2798H21.935V7.5398L16.005 16.1398Z',
      key: 'trufec',
    },
  ],
]);

export default SortByAlpha;
